import { render, staticRenderFns } from "./ContactEdit.vue?vue&type=template&id=4fe25468&scoped=true&"
import script from "./ContactEdit.vue?vue&type=script&lang=js&"
export * from "./ContactEdit.vue?vue&type=script&lang=js&"
import style0 from "./ContactEdit.vue?vue&type=style&index=0&id=4fe25468&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe25468",
  null
  
)

export default component.exports